import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./App.css";
import React from "react";
import Landing from "./components/Landing";
import "./index.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
